<!-- @format -->

<!-- ACCOUNT / CLIENT / BRANCH INFO (outside card) -->
<div class="context-info">
	<span *ngIf="currentRole === Roles.superAdmin"
		>Account: {{ selectedValues.company.companyName }} &nbsp;|&nbsp;
	</span>
	Client: {{ selectedValues.plant.plantName }} &nbsp;|&nbsp; Branch:
	{{ selectedValues.unit.unitName }}
</div>

<div class="card custom-section">
	<div class="header">
		<div>
			<h1 class="section-title">Create a New Form</h1>
			<p class="subtext">
				Complete the steps below to create a new form to be used.
			</p>
		</div>
		<a class="cancel-link" (click)="transferData()">Cancel</a>
	</div>

	<!-- STEPPER -->
	<div class="custom-stepper">
		<div
			class="custom-stepper__step"
			(click)="setActiveStep(1)"
			[ngClass]="{'active': activeStep === 1, 'completed': activeStep > 1}">
			<div class="step-label-row">
				<span>STEP 1</span>
				<span *ngIf="activeStep > 1" class="step-badge step-badge--done">&#10003;</span>
				<span *ngIf="activeStep === 1" class="step-badge step-badge--active">!</span>
			</div>
			<small>Details</small>
		</div>

		<div
			class="custom-stepper__step"
			(click)="activeStep > 1 ? setActiveStep(2) : null"
			[ngClass]="{'active': activeStep === 2, 'completed': activeStep > 2}">
			<div class="step-label-row">
				<span>STEP 2</span>
				<div>
				<span *ngIf="activeStep > 2" class="step-badge step-badge--done">&#10003;</span>
				<span *ngIf="activeStep === 2" class="step-badge step-badge--active">!</span>
				</div>
			</div>
			<small>Layout &amp; Configuration</small>
		</div>

		<div
			class="custom-stepper__step"
			(click)="activeStep > 2 ? setActiveStep(3) : null"
			[ngClass]="{'active': activeStep === 3}">
			<div class="step-label-row">
				<span>STEP 3</span>
				<span *ngIf="activeStep === 3" class="step-badge step-badge--active">!</span>
			</div>
			<small>Submission Guards</small>
		</div>
	</div>

	<!-- STEP 1: Details -->
	<div
		*ngIf="activeStep == 1"
		class="custom-stepper__step1">
		<label
			for="form_type"
			class="custom-label required"
			>Form Type</label>
		<app-dropdown
			[disabled]="false"
			[options]="formTypeOptions"
			[fields]="['id', 'name']"
			placeholder="Choose form type"
			selectedItem="{{ addLogsheetRequest.formType }}"
			[label]="addLogsheetRequest.formType || 'Choose form type'"
			(onSelectOption)="onFormTypeSelect($event)"></app-dropdown>
		<div class="form-group"></div>

		<label
			for="logsheet_name"
			class="custom-label required"
			>Form Name</label
		>
		<input
			type="text"
			class="custom-input"
			name="logsheet_name"
			id="logsheet_name"
			maxlength="50"
			minlength="3"
			[(ngModel)]="addLogsheetRequest.logSheetName" />

		<!-- Integrations -->
		<div class="integration-section">
			<div class="integration-header">
				<label class="custom-label integration-label">Integrations</label>
				<span class="integration-optional">Optional — connect your integrations</span>
			</div>

			<div *ngFor="let cI of this.selectedCloudIntegrations" class="integration-assigned-row">
				<span class="integration-assigned-icon">
					<span class="picker-category-icon picker-category-icon--cloud">
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none">
							<path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" stroke="#93c5fd" stroke-width="2"
								stroke-linecap="round" stroke-linejoin="round" />
						</svg>
					</span>
				</span>
				<span class="integration-assigned-name">Connection: {{ cI.connectionName }}</span>
				<span class="integration-assigned-url">{{ cI.prefix }}</span>
				<span class="integration-status-dot"
					[ngClass]="cI.connectionStatus === true ? 'dot-active' : 'dot-inactive'"></span>
				<span class="integration-status-text">{{ cI.connectionStatus === true ? 'Active' :
					'Inactive' }}</span>
				<button *ngIf="currentRole !== 'Super Admin'" class="integration-remove-btn" (click)="removeCloudAssignment(cI.cloudIntegrationId!)">
					<img src="../assets/checkbox-remove.svg" alt="remove" />
				</button>
			</div>
			<div *ngFor="let ep of assignedApiEndpoints" class="integration-assigned-row">
				<span class="integration-assigned-icon">
					<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" stroke="#2563eb"
							stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						<path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" stroke="#2563eb"
							stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
					</svg>
				</span>
				<span class="integration-assigned-name">{{ ep.displayName }}</span>
				<span class="integration-assigned-url">{{ ep.url }}</span>
				<span class="integration-status-dot"
					[ngClass]="ep.status === 'Active' ? 'dot-active' : 'dot-inactive'"></span>
				<span class="integration-status-text">{{ ep.status }}</span>
				<button *ngIf="currentRole !== 'Super Admin'" class="integration-remove-btn" (click)="removeApiEndpointAssignment(ep.apiEndpointConfigId!)">
					<img src="../assets/checkbox-remove.svg" alt="remove" />
				</button>
			</div>

			<p *ngIf="currentRole === 'Super Admin' && selectedCloudIntegrations.length === 0 && assignedApiEndpoints.length === 0"
				class="integration-empty-state">No integrations configured for this form</p>

			<button type="button" *ngIf="currentRole !== 'Super Admin'" class="btn-add-integration" (click)="openPicker()">
				<span class="btn-add-integration__plus">+</span> Add Integration
			</button>
		</div>
	</div>

	<!-- STEP 2: Layout & Configuration -->
	<div
		*ngIf="activeStep == 2"
		class="custom-stepper__step2">
		<div class="custom-stepper__step2-container">

			<!-- SECTION 1: Form Fields (left panel) -->
			<div class="section1">
				<div class="mr-28">
					<h3>Form Fields</h3>
					<ul class="instructions">
						<li>Check fields to add them to your form</li>
					</ul>
				</div>
				<div class="search-bar">
					<img
						src="../assets/search.svg"
						alt="search" />
					<input
						type="text"
						placeholder="Search fields..."
						[(ngModel)]="searchText" />
				</div>
				<div
					class="data-point-list"
					*ngIf="activeDataPoints.length > 0">
					<app-checked-card
						*ngFor="
							let data of activeDataPoints
								| search : searchText : 'dataPointName';
							let i = index
						"
						[attr.data-index]="i"
						[title]="data?.dataPointName"
						[dataTypeName]="data?.dataType"
						[description]="data?.dataPointDescription"
						(onClickIcon)="
							isSelectedDataPoint(data)
								? null
								: addDataPoint(data)
						"
						[isSelected]="isSelectedDataPoint(data)"
						[icon]="
							isSelectedDataPoint(data)
								? 'checkbox-selected.svg'
								: 'checkbox-unselected.svg'
						"></app-checked-card>
				</div>
			</div>

			<!-- SECTION 2: Layout (right panel) -->
			<div class="section2">
				<div class="mr-28">
					<h3>{{ addLogsheetRequest.logSheetName }}</h3>
					<ul class="instructions">
						<li>Click a field to set conditions</li>
						<li class="instructions-drag">
							<span class="instructions-drag__content">
								Drag
								<img src="../assets/dragger.svg" alt="drag handle" />
								to reorder
							</span>
						</li>
					</ul>
				</div>

				<!-- FIELD LIST -->
				<div
					class="data-point-list"
					*ngIf="selectDataPoints.length > 0"
					cdkDropList
					[cdkDropListData]="selectDataPoints"
					(cdkDropListDropped)="drop($event)">
					<div
						*ngFor="let field of selectDataPoints; let i = index"
						cdkDrag
						class="field-row-wrapper">
						<div
							class="field-row"
							[ngClass]="{'field-row--active': activeFieldIndex === i}"
							(click)="toggleFieldPanel(i)">
							<div cdkDragHandle class="drag-handle">
								<img src="../assets/dragger.svg" alt="drag" />
							</div>
							<div class="field-row__name-group">
								<span class="field-row__name">{{ field.dataPoint.dataPointName }}</span>
								<span *ngIf="field.requiredWhenVisible" class="field-row__required">(Required)</span>
								<span *ngIf="!field.requiredWhenVisible && field.mandatoryWhenVisible" class="field-row__required field-row__mandatory">(Mandatory)</span>
								<span *ngIf="!field.requiredWhenVisible && !field.mandatoryWhenVisible" class="field-row__optional">(Optional)</span>
							</div>
							<button
								type="button"
								class="field-badge field-badge--action"
								[ngClass]="getBadgeClass(field)"
								(click)="onFieldBadgeClick(i, $event)">
								{{ field.hiddenByDefault ? 'Conditional' : 'Always shown' }}
							</button>
							<span
								class="field-row__chevron"
								[ngClass]="{'chevron-up': activeFieldIndex === i}">
							</span>
							<button
								class="field-row__remove"
								(click)="$event.stopPropagation(); removeDataPoint(i)">
								<img src="../assets/checkbox-remove.svg" alt="remove" />
							</button>
						</div>

						<!-- CONDITION PANEL -->
						<div *ngIf="activeFieldIndex === i" class="condition-panel">
							<p class="condition-note">
								Conditions set here apply only within the form being edited.
							</p>
							<p class="condition-settings-label">Condition Settings</p>

							<div *ngIf="!field.hiddenByDefault" class="condition-info-box">
								<span class="condition-info-icon">&#9432;</span>
								<span>This field is always visible. Toggle below to make it conditional</span>
							</div>

							<div class="condition-toggle-row">
								<div>
									<p class="toggle-label">Hidden by default</p>
									<p class="toggle-sublabel" *ngIf="field.hiddenByDefault">
										Only shown when condition is met
									</p>
								</div>
								<app-custom-switch
									[enabled]="field.hiddenByDefault"
									(onToggle)="onToggleHiddenByDefault($event)">
								</app-custom-switch>
							</div>

							<div *ngIf="field.hiddenByDefault" class="condition-builder">
								<p class="condition-builder-label">Show this field when</p>

								<p class="condition-col-label">Source Field</p>
								<app-dropdown
									[options]="getSourceFieldOptions(i)"
									[fields]="['id', 'name']"
									[label]="getSourceFieldLabel(field)"
									(onSelectOption)="onSourceFieldSelect($event, field)">
								</app-dropdown>

								<div class="condition-builder-row">
									<div class="condition-builder-operator">
										<p class="condition-col-label">Function</p>
										<app-dropdown
											[options]="operatorOptions"
											[fields]="['id', 'name']"
											[label]="field.operator || 'Equal (=)'"
											(onSelectOption)="onOperatorSelect($event, field)">
										</app-dropdown>
									</div>
									<div class="condition-builder-value"
									*ngIf="field.operator !== 'Is Empty' && field.operator !== 'Is Not Empty'">
										<p class="condition-col-label">Value</p>
										<input
											type="text"
											class="custom-input condition-value-input"
											[(ngModel)]="field.conditionValue"
											placeholder="Value" />
									</div>
								</div>

								<div class="condition-toggle-row condition-toggle-row--after-builder">
									<div>
										<p class="toggle-label">Required when visible</p>
										<p class="toggle-sublabel">
											When enabled, this hidden field must be filled after it becomes visible.
										</p>
									</div>
									<app-custom-switch
										[enabled]="field.requiredWhenVisible"
										(onToggle)="onToggleRequiredWhenVisible($event)">
									</app-custom-switch>
								</div>
							</div>

							<div class="condition-toggle-row condition-toggle-row--section">
								<div>
									<p class="toggle-label toggle-label--emphasis">Mandatory</p>
									<p class="toggle-sublabel">
										Use this for fields that are always visible. For hidden-by-default fields, use “Required when visible” above.
									</p>
								</div>
								<app-custom-switch
									[enabled]="field.mandatoryWhenVisible"
									(onToggle)="onToggleMandatoryWhenVisible($event)">
								</app-custom-switch>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>

	<!-- STEP 3: Submission Guards -->
	<div *ngIf="activeStep == 3" class="custom-stepper__step3">
		<div class="guard-section">
			<h3 class="guard-section__title" style="color: #374151; font-size: larger;">Submission Guards</h3>
			<p class="guard-section__desc">
				Alert submitters of anomalies during submission, while the platform enforces configurable business thresholds without needing developer changes.
			</p>

			<!-- Guard list -->
			<div class="guard-list">
				<div
					*ngFor="let guard of guards; let i = index"
					class="guard-item">

					<!-- Collapsed row -->
					<div class="guard-row" (click)="toggleGuard(i)">
						<span class="guard-row__label">{{ guard.label }}</span>
						<span
							class="guard-type-badge"
							[ngClass]="guard.guardType === 'Advisory' ? 'badge-advisory' : 'badge-acknowledged'">
							{{ guard.guardType }}
						</span>
						<button
							type="button"
							class="guard-row__chevron-btn"
							(click)="$event.stopPropagation(); toggleGuard(i)">
							<span
								class="guard-chevron"
								[ngClass]="{'guard-chevron--up': guard.expanded}">
							</span>
						</button>
						<button
							type="button"
							class="guard-row__remove"
							(click)="$event.stopPropagation(); removeGuard(i)">
							<img src="../assets/checkbox-remove.svg" alt="remove" />
						</button>
					</div>

					<!-- Expanded panel -->
					<div *ngIf="guard.expanded" class="guard-panel">
						<!-- Row 1: Label + Priority -->
						<div class="guard-panel__row guard-panel__row--two-col">
							<div class="guard-panel__field">
								<label class="guard-field-label">Guard Label</label>
								<input
									type="text"
									class="custom-input"
									[(ngModel)]="guard.label"
									placeholder="Guard label" />
							</div>
							<div class="guard-panel__field">
								<label class="guard-field-label">Priority (lower value runs first)</label>
								<input
									type="number"
									class="custom-input"
									[(ngModel)]="guard.priority"
									min="1" />
							</div>
						</div>

						<!-- Row 2: Guard type selector -->
						<div class="guard-type-selector">
							<button
								type="button"
								class="guard-type-btn"
								[ngClass]="{'guard-type-btn--advisory-active': guard.guardType === 'Advisory'}"
								(click)="selectGuardType(i, 'Advisory')">
								<span class="guard-type-btn__title">Advisory</span>
								<small class="guard-type-btn__desc">Shows warning; submitter can proceed anyway</small>
							</button>
							<button
								type="button"
								class="guard-type-btn"
								[ngClass]="{'guard-type-btn--acknowledged-active': guard.guardType === 'Acknowledged'}"
								(click)="selectGuardType(i, 'Acknowledged')">
								<span class="guard-type-btn__title">Acknowledge</span>
								<small class="guard-type-btn__desc">Requires checkbox before submit is allowed</small>
							</button>
						</div>

						<!-- Row 3: Source Field + Function + Threshold (Advisory only) -->
						<div *ngIf="guard.guardType === 'Advisory'" class="guard-panel__row guard-panel__row--three-col">
							<div class="guard-panel__field">
								<label class="guard-field-label">Source Field</label>
								<app-dropdown
									[options]="guardSourceFieldOptions"
									[fields]="['id', 'name']"
									[label]="getGuardSourceFieldLabel(guard)"
									(onSelectOption)="onGuardSourceFieldSelect($event, guard)">
								</app-dropdown>
							</div>
							<div class="guard-panel__field">
								<label class="guard-field-label">Function</label>
								<app-dropdown
									[options]="guardOperatorOptions"
									[fields]="['id', 'name']"
									[label]="getGuardOperatorLabel(guard)"
									(onSelectOption)="onGuardOperatorSelect($event, guard)">
								</app-dropdown>
							</div>
							<div class="guard-panel__field">
								<label class="guard-field-label">Threshold</label>
								<input
									type="text"
									class="custom-input"
									[(ngModel)]="guard.thresholdValue"
									placeholder="e.g. 90" />
							</div>
						</div>

						<!-- Row 4: Warning message -->
						<div class="guard-panel__field">
							<label class="guard-field-label">Warning message</label>
							<p *ngIf="guard.guardType === 'Advisory'" class="guard-field-hint">Use
								<code>&#123;value&#125;</code> to insert the submitted field value in the message.
							</p>
							<textarea class="custom-input guard-message-textarea" [(ngModel)]="guard.warningMessage"
								[placeholder]="getGuardWarningPlaceholder(guard.guardType)" rows="3">
							</textarea>
						</div>
					</div>
				</div>
			</div>

			<!-- Add guard button -->
			<button type="button" class="guard-add-btn" (click)="addGuard()">
				Add Submission Guard
			</button>
		</div>
	</div>

	<!-- BUTTONS (always visible) -->
	<div class="step__btn-group">
		<button
			type="button"
			class="btn-outline"
			(click)="activeStep == 1 ? transferData() : setActiveStep(activeStep - 1)">
			Back
		</button>
		<button
			[ngClass]="!enableNextBtn() ? 'disabled-btn' : ''"
			[disabled]="!enableNextBtn()"
			(click)="activeStep < 3 ? setActiveStep(activeStep + 1) : showSaveModal()"
			type="submit"
			class="btn-fill">
			{{ activeStep < 3 ? "Next" : "Save" }}
		</button>
	</div>
</div>

<div *ngIf="pickerOpen" class="picker-backdrop" (click)="closePicker()">
	<div class="picker-modal" (click)="$event.stopPropagation()">
		<div class="picker-body">
			<h2 class="picker-title">Add Integration</h2>

			<div *ngIf="pickerScreen === 'category'">
				<div class="picker-category-section">
					<p class="picker-category-heading">Available integrations</p>
					<button type="button" class="picker-category-card" (click)="goToApiEndpoints()">
						<span class="picker-category-icon picker-category-icon--api">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none">
								<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" stroke="#2563eb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
								<path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" stroke="#2563eb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							</svg>
						</span>
						<span class="picker-category-info">
							<span class="picker-category-label">API Endpoints</span>
							<span class="picker-category-sub">{{ availableApiEndpointSummary }}</span>
						</span>
						<span class="picker-category-arrow">›</span>
					</button>
				</div>

				<div class="picker-category-section">
					<p class="picker-category-heading">Cloud storage</p>
					<button type="button" class="picker-category-card picker-category-card--disabled">
						<span class="picker-category-icon picker-category-icon--cloud">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none">
								<path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" stroke="#93c5fd" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							</svg>
						</span>
						<span class="picker-category-info">
							<span class="picker-category-label">Cloud Storage</span>
							<span class="picker-category-sub">Configure from integrations</span>
						</span>
					</button>
				</div>
			</div>

			<div *ngIf="pickerScreen === 'api-endpoints'">
				<p class="picker-breadcrumb" (click)="goToCategory()">‹ Integration types</p>

				<div *ngIf="pickerEndpoints.length === 0" class="picker-empty">
					<p class="picker-empty-text">No API endpoints available.</p>
					<a class="picker-configure-link" (click)="navigateToIntegrations()">Configure API endpoints</a>
				</div>

				<div
					*ngFor="let endpoint of pickerEndpoints"
					class="picker-endpoint-row"
					[ngClass]="{'picker-endpoint-row--selected': pickerSelectedId === endpoint.apiEndpointConfigId}"
					(click)="selectPickerEndpoint(endpoint.apiEndpointConfigId)">
					<span class="picker-endpoint-status-dot" [ngClass]="endpoint.status === 'Active' ? 'dot-active' : 'dot-inactive'"></span>
					<span class="picker-endpoint-info">
						<span class="picker-endpoint-name">{{ endpoint.displayName }}</span>
						<span class="picker-endpoint-url">{{ endpoint.url }}</span>
					</span>
					<button
						type="button"
						class="picker-select-btn"
						[ngClass]="{'picker-select-btn--selected': pickerSelectedId === endpoint.apiEndpointConfigId}">
						{{ pickerSelectedId === endpoint.apiEndpointConfigId ? 'Selected' : 'Select' }}
					</button>
				</div>
			</div>
		</div>

		<div class="picker-footer">
			<button type="button" class="btn-outline picker-footer-btn" (click)="closePicker()">Cancel</button>
			<button type="button" class="btn-fill picker-footer-btn" (click)="confirmPickerSelection()">Add</button>
		</div>
	</div>
</div>

<app-success-toast *ngIf="toastService.showToast"></app-success-toast>
<app-save-modal
	*ngIf="dialogService.showModal"
	(onSave)="addLogsheet()"></app-save-modal>
